export const safeJsonParse = <T>(
  jsonString: unknown,
  options?: { onError?: (error: unknown) => void; parse?: (payload: string) => T }
): T | undefined => {
  const { onError, parse = JSON.parse } = options ?? {};

  try {
    return parse(jsonString as string);
  } catch (parseError) {
    onError?.(parseError);

    return undefined;
  }
};
